import FollowerMatrix from "./follower-matrix";

export default FollowerMatrix;